var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#ED745D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70508 17.5088H14.2949C15.0811 17.5088 15.5107 17.1133 15.5449 16.3467L15.8525 9.42773H16.4238C16.751 9.42773 16.9902 9.19336 16.9902 8.87109C16.9902 8.55371 16.751 8.32422 16.4238 8.32422H14.4121V7.62109C14.4121 6.7666 13.8799 6.2832 12.9277 6.2832H11.0674C10.1152 6.2832 9.57812 6.7666 9.57812 7.62109V8.32422H7.57129C7.24902 8.32422 7.00488 8.55371 7.00488 8.87109C7.00488 9.19824 7.24902 9.42773 7.57129 9.42773H8.14746L8.45508 16.3467C8.48438 17.1133 8.91895 17.5088 9.70508 17.5088ZM10.833 7.65527C10.833 7.47949 10.9502 7.37695 11.1504 7.37695H12.8398C13.0449 7.37695 13.1621 7.47949 13.1621 7.65527V8.32422H10.833V7.65527ZM10.3984 15.8291C10.1689 15.8291 10.0078 15.6729 10.0029 15.4434L9.85645 10.4873C9.85156 10.2529 10.0029 10.0967 10.2422 10.0967C10.4814 10.0967 10.6426 10.2529 10.6475 10.4824L10.7939 15.4336C10.7988 15.668 10.6475 15.8291 10.3984 15.8291ZM12 15.8291C11.7607 15.8291 11.5996 15.6777 11.5996 15.4434V10.4824C11.5996 10.2529 11.7607 10.0967 12 10.0967C12.2344 10.0967 12.3955 10.2529 12.3955 10.4824V15.4434C12.3955 15.6777 12.2344 15.8291 12 15.8291ZM13.5967 15.8291C13.3525 15.8291 13.1963 15.668 13.2012 15.4385L13.3477 10.4824C13.3525 10.2529 13.5137 10.1016 13.7529 10.1016C13.9922 10.1016 14.1484 10.2529 14.1387 10.4873L13.9971 15.4434C13.9922 15.6729 13.8262 15.8291 13.5967 15.8291Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.6b54b734dce7480b160f68f820606949.svg";
export { ForwardRef as ReactComponent };